/**
 * HiKNIGHT — Swiper carousels (category / influencer / reviews).
 * Swiper is defer-loaded in theme.liquid; we wait until it exists.
 */
(() => {
  if (window.__HK_MWC_INIT__) return;
  window.__HK_MWC_INIT__ = 1;

  function waitSwiper(cb) {
    if (typeof window.Swiper !== 'undefined') {
      cb();
      return;
    }
    requestAnimationFrame(() => waitSwiper(cb));
  }

  function breakpointsFor(variant, root) {
    if (variant === 'category' && root) {
      const mode = (root.dataset.catDesktopSlides || 'auto').trim();
      const space = Number.parseInt(root.dataset.spaceBetween || '12', 10) || 12;
      const gapMd = Math.max(space, 12);
      const gapLg = Math.max(space, 16);
      if (mode && mode !== 'auto') {
        const n = Math.min(5, Math.max(2, Number.parseInt(mode, 10) || 3));
        const nMd = Math.min(n, 3);
        return {
          768: { slidesPerView: nMd, spaceBetween: gapMd },
          1000: { slidesPerView: n, spaceBetween: gapLg },
        };
      }
      /* Fixed card width via CSS — never use 1.12 here (blows slides to ~full row). */
      return {
        768: { slidesPerView: 'auto', spaceBetween: gapMd },
        1000: { slidesPerView: 'auto', spaceBetween: gapLg },
      };
    }
    if (variant === 'review') {
      return {
        768: { slidesPerView: 2.2, spaceBetween: 14 },
        1100: { slidesPerView: 3.4, spaceBetween: 16 },
      };
    }
    return {
      768: { slidesPerView: 2.2, spaceBetween: 14 },
      1000: { slidesPerView: 3.2, spaceBetween: 18 },
    };
  }

  function closeLightbox(root) {
    const box = root.querySelector('[data-hk-mwc-lightbox]');
    const frame = root.querySelector('[data-hk-mwc-lightbox-frame]');
    if (!box) return;
    box.setAttribute('hidden', '');
    if (frame) frame.innerHTML = '';
    document.documentElement.style.overflow = '';
  }

  function openLightbox(root, embedUrl) {
    const box = root.querySelector('[data-hk-mwc-lightbox]');
    const frame = root.querySelector('[data-hk-mwc-lightbox-frame]');
    if (!box || !frame || !embedUrl) return;
    frame.innerHTML = `<iframe title="Video" src="${embedUrl}" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen loading="lazy"></iframe>`;
    box.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
  }

  function youtubeEmbedFromUrl(url) {
    if (!url || typeof url !== 'string') return '';
    const u = url.trim();
    let m = u.match(/(?:youtube\.com\/watch\?v=|youtube\.com\/shorts\/|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    if (m) return `https://www.youtube.com/embed/${m[1]}?autoplay=1&rel=0&playsinline=1`;
    m = u.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/);
    if (m) return `https://www.youtube.com/embed/${m[1]}?autoplay=1&rel=0&playsinline=1`;
    return '';
  }

  function initSwiperRoot(root) {
    if (!root || root.dataset.hkMwcReady === 'true') return;
    const swiperEl = root.querySelector('.js-hk-mwc-swiper');
    const prev = root.querySelector('.js-hk-mwc-prev');
    const next = root.querySelector('.js-hk-mwc-next');
    const pag = root.querySelector('.js-hk-mwc-pagination');
    if (!swiperEl || !prev || !next || !pag) return;

    const variant = root.getAttribute('data-hk-mwc-variant') || 'category';
    const rawMobile = (root.dataset.slidesMobile || '1.12').trim();
    const slidesMobile = rawMobile === '2' ? 2 : Number.parseFloat(rawMobile) || 1.12;
    const spaceBetween = Number.parseInt(root.dataset.spaceBetween || '12', 10) || 12;
    const catDesktopMode = (root.dataset.catDesktopSlides || 'auto').trim();
    const categoryUsesAutoSlides =
      variant === 'category' && (!catDesktopMode || catDesktopMode === 'auto');

    const swiper = new window.Swiper(swiperEl, {
      slidesPerView: categoryUsesAutoSlides ? 'auto' : slidesMobile,
      spaceBetween,
      speed: 450,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
      pagination: {
        el: pag,
        type: 'progressbar',
      },
      breakpoints: breakpointsFor(variant, root),
    });

    root._hkMwcSwiper = swiper;
    root.dataset.hkMwcReady = 'true';
  }

  function destroySwiperRoot(root) {
    closeLightbox(root);
    const sw = root._hkMwcSwiper;
    if (sw && typeof sw.destroy === 'function') {
      sw.destroy(true, true);
    }
    delete root._hkMwcSwiper;
    delete root.dataset.hkMwcReady;
  }

  function initAll(container) {
    const rootNode = container && container.nodeType === 1 ? container : document;
    rootNode.querySelectorAll('[data-hk-mwc-root]').forEach((el) => {
      if (rootNode !== document && !rootNode.contains(el)) return;
      waitSwiper(() => initSwiperRoot(el));
    });
  }

  function unloadSection(event) {
    const t = event.target;
    if (!t || typeof t.querySelectorAll !== 'function') return;
    t.querySelectorAll('[data-hk-mwc-root]').forEach(destroySwiperRoot);
  }

  document.addEventListener('click', (e) => {
    const closeEl = e.target.closest('[data-hk-mwc-lightbox-close]');
    if (closeEl) {
      const root = closeEl.closest('[data-hk-mwc-root]');
      if (root) {
        e.preventDefault();
        closeLightbox(root);
      }
      return;
    }

    const btn = e.target.closest('[data-hk-mwc-video-url]');
    if (!btn) return;
    const embed = youtubeEmbedFromUrl(btn.getAttribute('data-hk-mwc-video-url') || '');
    if (!embed) return;
    e.preventDefault();
    const root = btn.closest('[data-hk-mwc-root]');
    if (root) openLightbox(root, embed);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-hk-mwc-lightbox]:not([hidden])').forEach((box) => {
      const root = box.closest('[data-hk-mwc-root]');
      if (root) closeLightbox(root);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:unload', unloadSection);
})();
